import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { init as initApm } from '@elastic/apm-rum';
import { ELASTIC_APM_ENVIRONMENT, REACT_ELASTIC_APM_URL } from './common/components/utils/constants';


const apm = initApm({
  serviceName: 'cad-ghs-app',
  serverUrl: REACT_ELASTIC_APM_URL,
  // "http://localhost:8200/",
  // Set the service version (required for source map feature)
  serviceVersion: '1.0',
  logLevel: 'debug',
  environment: ELASTIC_APM_ENVIRONMENT,
});

// Generic listener to track button clicks
document.addEventListener('click', (e) => {
  const el = (e.target as HTMLElement)?.closest('button, a, [role="button"]');
  if (!el) return;
 
  const label =
    el.getAttribute('aria-label') ||
    el.getAttribute('data-label') ||
    el.getAttribute('title') ||
    el.id ||
    el.getAttribute('name') ||
    el.textContent?.trim() ||
    'unknown-button';
 
  // Start a custom span to track it
  const span = apm.startSpan(`Click - ${label}`, 'user-interaction');
 
  // Optional: end the span after a delay
  setTimeout(() => {
    if (span) span.end();
  }, 100);
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
